import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.getModel != null && _ctx.getModel.mainLogoUrl == null && _ctx.getModel.hasMainLogo)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: '/api/models/' + _ctx.getModel.id + '/main-logo',
          style: {"margin-top":"2px","height":"32px","margin-left":"10px","margin-right":"10px"}
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.getModel != null && _ctx.getModel.mainLogoUrl != null && _ctx.getModel.hasMainLogo)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          target: "_blank",
          href: _ctx.getModel.mainLogoUrl
        }, [
          _createElementVNode("img", {
            src: '/api/models/' + _ctx.getModel.id + '/main-logo',
            style: {"margin-top":"2px","max-height":"24px","margin-left":"10px","margin-right":"10px"}
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.getModel != null && _ctx.getModel.secondaryLogoUrl == null && _ctx.getModel.hasSecondaryLogo)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: '/api/models/' + _ctx.getModel.id + '/secondary-logo',
          style: {"margin-top":"2px","height":"32px","margin-left":"10px","margin-right":"10px"}
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.getModel != null && _ctx.getModel.secondaryLogoUrl != null && _ctx.getModel.hasSecondaryLogo)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          target: "_blank",
          href: _ctx.getModel.secondaryLogoUrl
        }, [
          _createElementVNode("img", {
            src: '/api/models/' + _ctx.getModel.id + '/secondary-logo',
            style: {"margin-top":"2px","max-height":"24px","margin-left":"10px","margin-right":"10px"}
          }, null, 8, _hoisted_6)
        ], 8, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}